import { atom } from "jotai";

export const sidebarOpenAtom = atom(false);
export const hasSidebarAtom = atom(false);
